import { render, staticRenderFns } from "./BatchAppBar.vue?vue&type=template&id=6c80012e"
import script from "./BatchAppBar.vue?vue&type=script&lang=js"
export * from "./BatchAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports